import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import And from 'ant-design-vue';
import router from './router'
import 'ant-design-vue/dist/antd.css';
import '../public/style.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueI18n from 'vue-i18n'
import VideoPlayer from 'vue-video-player'

// 引入方式一
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'



Vue.use(VideoPlayer)
Vue.use(VueI18n)
Vue.use(VueAwesomeSwiper)
Vue.use(And);
Vue.config.productionTip = false

const i18n = new VueI18n({
    locale:(function(){
        if(localStorage.getItem('lang')){
            return localStorage.getItem('lang')
        }
        return 'zh'
    }()),
    messages:{
        'en':require('./assets/language/en'), //英文语言包
        'zh':require('./assets/language/zh'), //中文包
    }
})
new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
